export const createProductGallery = (element) => {
  if (!element || element.length === 0) {
    return null;
  }

  const instance = {
    $element: null,
    $mainImage: null,
    $thumbnails: null,
    currentIndex: 0,

    init: function (element) {
      this.$element = jQuery(element);
      this.$mainImage = this.$element.find(".js-gallery-main-image");
      this.$thumbnails = this.$element.find(
        ".js-gallery-thumbnails .js-gallery-thumbnail"
      );

      // Add initial active state to first thumbnail
      this.$thumbnails.first().addClass("gallery-thumbnail--active");

      this.loadArrows();
      this.setupEventListeners();

      // Hide arrows if only one image
      if (this.$thumbnails.length <= 1) {
        this.$mainImage.find(".js-gallery-arrow").hide();
      }
    },

    loadArrows: function () {
      this.$mainImage.append(`
        <button class='js-gallery-arrow js-gallery-arrow-prev gallery-arrow gallery-arrow--prev' aria-label='Previous image'></button>
      `);
      this.$mainImage.append(`
        <button class='js-gallery-arrow js-gallery-arrow-next gallery-arrow gallery-arrow--next' aria-label='Next image'></button>
      `);
    },

    setupEventListeners: function () {
      // Only apply hover effects on medium screens and up
      if (window.matchMedia("(min-width: 768px)").matches) {
        this.$mainImage.on("mouseenter", () => {
          this.$mainImage
            .find(".js-gallery-arrow")
            .addClass("gallery-arrow--visible");
        });

        this.$mainImage.on("mouseleave", () => {
          this.$mainImage
            .find(".js-gallery-arrow")
            .removeClass("gallery-arrow--visible");
        });
      }

      // Add arrow click handlers
      this.$mainImage.find(".js-gallery-arrow-prev").on("click", () => {
        this.navigateGallery("prev");
      });

      this.$mainImage.find(".js-gallery-arrow-next").on("click", () => {
        this.navigateGallery("next");
      });

      // Modify thumbnail click handlers
      this.$thumbnails.each((index, thumb) => {
        jQuery(thumb)
          .find("a")
          .on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showImage(index);
            return false;
          });
      });
    },

    navigateGallery: function (direction) {
      const totalImages = this.$thumbnails.length;

      if (direction === "next") {
        this.currentIndex = (this.currentIndex + 1) % totalImages;
      } else {
        this.currentIndex = (this.currentIndex - 1 + totalImages) % totalImages;
      }

      this.showImage(this.currentIndex);
    },

    showImage: function (index) {
      // Remove active state from all thumbnails
      this.$thumbnails.removeClass("gallery-thumbnail--active");

      // Add active state to current thumbnail
      this.$thumbnails.eq(index).addClass("gallery-thumbnail--active");

      // Get the target thumbnail
      const $targetThumb = this.$thumbnails.eq(index);

      // Find the image data from the thumbnail
      const $thumbImage = $targetThumb.find(
        ".woocommerce-product-gallery__image"
      );
      const $thumbImg = $thumbImage.find("img");
      const largeImageUrl = $thumbImg.data("large_image");
      const largeImageWidth = $thumbImg.data("large_image_width");
      const largeImageHeight = $thumbImg.data("large_image_height");

      // Update main image
      const $mainImageWrapper = this.$mainImage.find(
        ".woocommerce-product-gallery__image"
      );
      const $mainImageLink = $mainImageWrapper.find("a");
      const $mainImg = $mainImageLink.find("img");

      // Update all relevant attributes
      $mainImageLink.attr("href", largeImageUrl);
      $mainImg.attr({
        src: largeImageUrl,
        "data-large_image": largeImageUrl,
        "data-large_image_width": largeImageWidth,
        "data-large_image_height": largeImageHeight,
        srcset: $thumbImg.attr("srcset"),
        sizes: $thumbImg.attr("sizes"),
      });

      // Force refresh
      $mainImg.trigger("load");

      // Trigger WooCommerce gallery update if available
      if (jQuery.fn.wc_product_gallery) {
        this.$element.trigger("woocommerce_gallery_update_image");
      }

      // Update current index
      this.currentIndex = index;
    },

    updateMainImage: function ({ full_src, src_w, src_h, srcset, sizes }) {
      const $firstThumb = this.$thumbnails.first();
      const $firstThumbLink = $firstThumb.find("a");
      const $firstThumbImage = $firstThumbLink.find("img");
      $firstThumbLink.attr("href", full_src);
      $firstThumbImage.attr({
        src: full_src,
        "data-large_image": full_src,
        "data-large_image_width": src_w,
        "data-large_image_height": src_h,
        srcset: srcset,
        sizes: sizes,
      });
      this.showImage(0);
    },
  };

  instance.init(element);
  return instance;
};
